import ISnapShotOptions from '../../interfaces/ISnapShotOptions';

const defaultSnapShotOptions: ISnapShotOptions = {
  snapshotincludewalldimensions: true,
  snapshotincludewallname: true,
  snapshotincludefloor: true,
  snapshotincludebuildingwall: true,
};

export default defaultSnapShotOptions;
